var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutGutters',{attrs:{"no-padding":""}},[_c('ContainerArea',{staticClass:"PlatformFooter"},[_c('v-row',{staticClass:"px-4",attrs:{"justify":"space-between"}},[_c('NotesActions',{staticClass:"pt-2"}),_vm._v(" "),_c('SocialActions',{staticClass:"pt-2"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }